import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { PlexEnvironment } from '@app/env';

@Injectable({
  providedIn: 'root',
})
export class GeneralLookupService {
  private http = inject(HttpClient);
  public environment = inject(PlexEnvironment);

  private BASE_URL = this.environment.apiUrl;

  _Cache: Map<string, any> = new Map();

  public get(_table: string, useCache: boolean = false): Promise<any> {

    if (useCache && this._Cache.has(_table)) {
      return Promise.resolve(this._Cache.get(_table));
    }
    let url = `${this.BASE_URL}${_table}?&%24count=true`;

    return this.http
      .get(url)
      .toPromise()
      .then(response => {
        if (useCache) {
          this._Cache.set(_table, response);
        }
        return response;
      });
  }

  public getNoCount(_table: string, useCache: boolean = false): Promise<any> {

    if (useCache && this._Cache.has(_table)) {
      return Promise.resolve(this._Cache.get(_table));
    }

    let url = `${this.BASE_URL}${_table}`;

    return this.http
      .get(url)
      .toPromise()
      .then(response => {
        if (useCache) {
          this._Cache.set(_table, response);
        }
        return response;
      });
  }

  public getFiltered(_url: string, useCache: boolean = false): Promise<any> {

    if (useCache && this._Cache.has(_url)) {
      return Promise.resolve(this._Cache.get(_url));
    }
    let url = `${this.BASE_URL}${_url}`;

    return this.http
      .get(url)
      .toPromise()
      .then(response => {
        if (useCache) {
          this._Cache.set(_url, response);
        }
        return response;
      });
  }

  public getById(_table: string, _id: number): Promise<any> {

    let query = `${_table}(${_id})`;
    let url = `${this.BASE_URL}${query}`;

    return this.http
      .get(url)
      .toPromise()
      .then(response => response);
  }

  public getByIdQ(_table: string, _id: any, q: string): Promise<any> {

    let query = `${_table}(${_id})${q}`;
    let url = `${this.BASE_URL}${query}`;

    return this.http
      .get(url)
      .toPromise()
      .then(response => response);
  }
  public getEndpoint(_general: string, _param: any, _endpoint: string): Promise<any> {

    let query = `${_general}/${_param}/${_endpoint}`;
    let url = `${this.BASE_URL}${query}`;

    return this.http
      .get(url)
      .toPromise()
      .then(response => response);
  }

  public getFilteredExpand(_table: string, _expandFilter: string, _value: any): Promise<any> {

    let query = `${_table}?$expand=${_expandFilter}${_value}`;
    let url = `${this.BASE_URL}${query}`;

    return this.http
      .get(url)
      .toPromise()
      .then(response => response);
  }

  public getExpand(_table: string, _expand: string): Promise<any> {

    let query = `${_table}?$expand=${_expand}`;
    let url = `${this.BASE_URL}${query}`;

    return this.http
      .get(url)
      .toPromise()
      .then(response => response);
  }
}